/** "Viko updated · Reload": shown when a new version took over while this page was visible. */
import { Button } from '@viko/transcript-ui'
import { RefreshCw } from 'lucide-react'
import { useEffect, useState } from 'react'
import { isSessionOnly } from '../lib/session-only.js'
import { UPDATE_READY_EVENT } from '../lib/sw-update.js'

export function UpdateNotice() {
  const [ready, setReady] = useState(false)
  useEffect(() => {
    const h = () => setReady(true)
    window.addEventListener(UPDATE_READY_EVENT, h)
    return () => window.removeEventListener(UPDATE_READY_EVENT, h)
  }, [])
  if (!ready) return null
  // "Just this session": the keys live only in this page, so a reload signs out (never automatic).
  const session = isSessionOnly()
  return (
    <div className="update-notice" role="status">
      <span>
        Viko updated
        {session ? (
          <span className="update-notice__note">
            {' '}
            · Reloading ends this session: you will sign in again.
          </span>
        ) : null}
      </span>
      <Button
        variant="primary"
        className="vk-btn--sm"
        icon={<RefreshCw size={14} aria-hidden="true" />}
        onClick={() => window.location.reload()}
      >
        Reload
      </Button>
    </div>
  )
}
